import { DropdownMenu, DropdownToggle } from 'reactstrap';
import { styled } from 'styled-components';

export const StyledDropdownMenu = styled(DropdownMenu)`
  width: 100%;
  font-family: ${(props) => props.theme.fonts.default};

  button {
    &:hover,
    &:active,
    &:focus {
      outline: none;
      box-shadow: none;
      background-color: transparent;
      color: black;
    }

    &:hover {
      color: ${(props) => props.theme.colors.primaryRed};
    }
  }
`;

export const StyledDropdownToggle = styled(DropdownToggle)`
  display: flex;
  align-items: center;
  color: ${(props) => props.theme.colors.white};
  background-color: ${(props) => props.theme.colors.primaryRed};
  border: none;
  font-family: ${(props) => props.theme.fonts.fontFamilySecondary};
  font-size: 1rem;
  font-weight: 500;
  justify-content: space-between;
  width: 100%;
  padding: 0.75rem 1.15rem;
  text-transform: uppercase;

  &:hover,
  &:active,
  &:focus {
    background-color: ${(props) => props.theme.colors.primaryRed} !important;
    outline: none;
    box-shadow: none;
  }

  @media (max-width: ${(props) => props.theme.breakpoints.sm}) {
    margin-bottom: 0.5rem;
  }
`;
